/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IEmbedYoutubeAndContentData } from './embed-youtube-and-content.data';
import { IEmbedYoutubeAndContentProps, IVideoDetailsData } from './embed-youtube-and-content.props.autogenerated';

export interface IEmbedYoutubeAndContentViewProps extends IEmbedYoutubeAndContentProps<IEmbedYoutubeAndContentData> {
    title: string;
    description: Msdyn365.RichText;
    videoDetails: IVideoDetailsData;
}

/**
 *
 * EmbedYoutubeAndContent component
 * @extends {React.PureComponent<IEmbedYoutubeAndContentProps<IEmbedYoutubeAndContentData>>}
 */
class EmbedYoutubeAndContent extends React.PureComponent<IEmbedYoutubeAndContentProps<IEmbedYoutubeAndContentData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const viewProps = {
            ...this.props,
            title: config.title,
            description: config.description,
            videoDetails: config.videoDetails
        };

        return this.props.renderView(viewProps);
    }
}

export default EmbedYoutubeAndContent;
